/* tslint:disable */
/* eslint-disable */
export enum DownloadStatus {
  None = 'NONE',
  Busy = 'BUSY',
  Ready = 'READY',
  Failed = 'FAILED'
}
